<script lang="ts">
import { computed } from 'vue';

export type ContainerSize = 'md' | 'lg' | 'xl';
export const DefaultSize: ContainerSize = 'lg';
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<{ size?: ContainerSize }>(), { size: DefaultSize });
const tailwindSizeClass = computed(() => {
  switch (props.size) {
    case 'md':
      return 'tw-max-w-[1078px]';
    case 'xl':
      return 'tw-max-w-[1600px]';

    case 'lg':
    default:
      return 'tw-max-w-[1200px]';
  }
});
</script>
<template>
  <div class="tw-mx-auto tw-w-full tw-grow tw-px-6" :class="tailwindSizeClass">
    <slot></slot>
  </div>
</template>
